// extracted by mini-css-extract-plugin
export default {"ul":"CompC_ul__rWmDQ","list":"CompC_list__Vfpa0","label":"CompC_label__gSj-c","checked":"CompC_checked__fEIW9"};